import ChatTopPanel from '../TopPanel/ChatTopPanel';
import ChatBody from './ChatBody';
import ChatInput from '../InputForm/ChatInput';
import { Box } from '@coolblue-development/freddy';
import EmptyState from '../../Common/EmptyState';
import { useChatContext } from '../../../../../contexts/ChatContext';

const ChatPage = (): JSX.Element => {
  const { selectedChat } = useChatContext();

  const renderBody = (): JSX.Element => {
    if (selectedChat === null) {
      return <EmptyState title="No active chat" />;
    }

    return (
      <>
        <ChatBody />
        <ChatInput />
      </>
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        boxShadow: '0px 4px 16px 0px #246CB429',
        borderRadius: '12px'
      }}
    >
      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <ChatTopPanel />
        {renderBody()}
      </Box>
    </Box>
  );
};

export default ChatPage;
